import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ title, author, date, readTime, description, slug, image }) => {
  return (
    <Link to={`/blog/${slug}`} className="blog-card cursor-pointer">
      <div className="cursor-pointer">
        <img src={image} alt={title} className="blog-image" />
        <div className="blog-content">
          <div className="metadata">
            {/* <span>Category</span> */}
            {/* <img src='/img/testimonials/rev1.png' alt="Dot" className="dot" /> */}
            <span>{date}</span>
            <img src='/img/testimonials/rev1.png' alt="Dot" className="dot" />
            <span>{readTime}</span>
          </div>
          <h2 className="title">{title}</h2>
          <p className="description">{description}</p>
          <div className="author-section">
            {/* <img src='/img/testimonials/rev1.png' alt="Author" className="avatar" /> */}
            <span className="author-name">{author}</span>
            <button className="read-more-button">Read more</button>
          </div>
        </div>
      </div>
    </Link>
  );
};

const AllBlogs = () => {
  const blogPosts = [
    {
      title: "Lipaworld partners with CheckUps to unlock healthcare benefits for families of Kenyans back at home",
      author: "Lipaworld",
      date: "September 30, 2024",
      readTime: "10min read",
      description: "The innovative partnership offers secure remittances and inclusive healthcare benefits to families in Kenya, bridging the gap between...",
      slug: "Lipaworld-partners-with-CheckUps",
      image: '/img/blog/checkups.png'
    },
    {
      title: "Lipaworld Accepted into Prestigious VentureCrushFG Pod Program",
      author: "Lipaworld",
      date: "July 25, 2024",
      readTime: "8min read",
      description: "Lipaworld, a leading innovator in digital financial solutions, is thrilled to announce its acceptance into the VentureCrushFG Pod program. This significant milestone marks a pivotal step in...",
      slug: "Lipaworld-Accepted-into-Prestigious-VentureCrushFG-Pod-Program",
      image: '/img/blog/ventureCrush.png'
    },
    {
      title: "5 Thoughtful Gift Ideas for Father&apos;s Day",
      author: "Lipaworld",
      date: "June 16, 2024",
      readTime: "12min read",
      description: "Father's Day is here, and finding the perfect gift for the man who has given you so much can be a challenge—especially...",
      slug: "5-Thoughtful-Gift-Ideas-for-Fathers-Day",
      image: '/img/blog/fathersday.jpg'
    },
    {
      title: " Lipaworld Secures First Place in Fintech Category at Startup 302 Pitch Competition",
      author: "Lipaworld",
      date: "May 20, 2024",
      readTime: "15min read",
      description: "Lipaworld, an innovative digital voucher marketplace, clinches first place in the Fintech Category at the prestigious...",
      slug: "lipaworld-secures-first-place-in-fintech-category-at-startup-302-pitch-competition",
      image: '/img/blog/ceo.jpg'
    },
    // {
    //   title: "The Rise of Mobile Payment Solutions",
    //   author: "David Rodriguez",
    //   date: "September 30, 2024",
    //   readTime: "10min read",
    //   description: "How mobile payment technologies are revolutionizing the way we handle money and make transactions.",
    //   slug: "rise-of-mobile-payments",
    //   image: '/img/blog/mobile-payments.png'
    // },
    // {
    //   title: "Sustainable Banking Practices",
    //   author: "Emma Thompson",
    //   date: "September 25, 2024",
    //   readTime: "7min read",
    //   description: "Discover how banks are incorporating environmental sustainability into their operations and services.",
    //   slug: "sustainable-banking-practices",
    //   image: '/img/blog/sustainable-banking.png'
    // }
  ];

  return (
    <div className="blogs-section">
      <h1 className='blogh1'>All Blogs</h1>
      <div className="blogs-grid">
        {blogPosts.map((post, index) => (
          <BlogCard
            key={index}
            {...post}
          />
        ))}
      </div>
    </div>
  );
};

export default AllBlogs;